// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__23bcu","NavLinkText":"NavigationItem__NavLinkText__2ZVWg","active":"NavigationItem__active__2zJdO","hover":"NavigationItem__hover__3iJqp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 278
// module chunks = 0